import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HowItWorksFootballComponent } from '../../tutorial/how-it-works-football/how-it-works-football.component';
import type { GamesTypes } from '@app/domain/enums/game';
import { HOW_IT_WORKS_CONTENT } from '@app/domain/enums/how-it-works-content.enum';
import { GAME_TYPE_LOGO_DARK_PATH, gameBrandLogos, gameTypeLogos } from '@app/domain/properties';

@Component({
  selector: 'bingo-tutorial-dialog',
  imports: [NgComponentOutlet, MatButton],
  templateUrl: './tutorial-dialog.component.html',
  styleUrl: './tutorial-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TutorialDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<TutorialDialogComponent>);
  private readonly data = inject<{ gameType: GamesTypes }>(MAT_DIALOG_DATA);

  readonly contentComponent = computed(() => HOW_IT_WORKS_CONTENT[this.gameType] ?? HowItWorksFootballComponent);

  protected get gameType(): GamesTypes {
    return this.data.gameType;
  }

  /** Goal Rush and Fantasy15 are separate brands with their own logos; every other type maps through `gameTypeLogos`. */
  protected get gameTypeLogoSrc(): null | string {
    const brandLogo = gameBrandLogos.get(this.data.gameType);

    if (brandLogo) {
      return brandLogo;
    }

    const logo = gameTypeLogos.get(this.data.gameType);

    return logo ? `${GAME_TYPE_LOGO_DARK_PATH}${logo}.svg` : null;
  }

  protected closeDialog(): void {
    this.dialogRef.close();
  }
}
